function getSortIcon(sortDirection) {
    switch (sortDirection) {
        case "asc":
            return "↑";
        case "desc":
            return "↓";
        default:
            return "";
    }
}

export { getSortIcon };
//# sourceMappingURL=getSortIcon.js.map
